export default {"src":"/_next/static/media/0xbe9895146f7af43049ca1c1ae358b0541ea49704.54d15be3.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};